import { render, staticRenderFns } from "./exchange-check.vue?vue&type=template&id=49e226a8&"
import script from "./exchange-check.vue?vue&type=script&lang=js&"
export * from "./exchange-check.vue?vue&type=script&lang=js&"
import style0 from "./exchange-check.vue?vue&type=style&index=0&id=49e226a8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports